import { AvatarSize } from "@components/Avatar";
import { NonprofitAvatar } from "@components/Avatar/NonprofitAvatar";
import { CardCover } from "@components/CardCover";
import {
  bottomLeftCss,
  bottomRightCss,
  CoverContainer,
  Gradient,
} from "@components/feed/NewNonprofitCard/Cover/styles";
import { MultiCausesPopover } from "@components/feed/NewNonprofitCard/MultiCausesPopover";

import { ContextNonprofit } from "src/context/NonprofitsContext/types";
import { useLoadImageWithPriorityContext } from "src/hooks/useLoadImageWithPriorityContext";

interface CoverProps {
  nonprofit: ContextNonprofit;
  highlightedCauses?: string[];
  onError?: () => void;
  rounded?: boolean;
  disableLink?: boolean;
  /**
   * Width in CSS pixels this cover renders at above a 1000px viewport, used as
   * the `sizes` hint the browser picks a srcset candidate from.
   *
   * Pass it when the page's layout gives the card a measured width other than
   * the shared default, e.g. the 410px card on the search page.
   */
  largeScreenWidth?: number;
}

export function Cover({
  nonprofit,
  highlightedCauses,
  onError,
  rounded = true,
  disableLink = false,
  largeScreenWidth,
}: CoverProps) {
  const nonprofitWithImagePriority = useLoadImageWithPriorityContext();

  const showGradient =
    nonprofit.nonprofitTags?.length || nonprofit.logoCloudinaryId;
  return (
    <div css={{ position: "relative" }}>
      <CoverContainer rounded={rounded}>
        <CardCover
          coverImageCloudinaryId={nonprofit.coverImageCloudinaryId}
          alt={nonprofit.metadata?.coverImageAltText}
          onError={onError}
          priority={nonprofitWithImagePriority.includes(nonprofit.id)}
          largeScreenWidth={largeScreenWidth}
        />
      </CoverContainer>
      {showGradient && <Gradient />}
      <div css={bottomLeftCss}>
        <MultiCausesPopover
          nonprofitTags={nonprofit.nonprofitTags}
          highlightedCauses={highlightedCauses}
        />
      </div>
      {nonprofit.logoCloudinaryId && (
        <div css={bottomRightCss}>
          <NonprofitAvatar
            size={AvatarSize.MEDIUM}
            nonprofit={nonprofit}
            drawBorder
            disablePlaceholder
            disableLink={disableLink}
          />
        </div>
      )}
    </div>
  );
}
